import { BYO_OPEN_MODAL, BYO_CLOSE_MODAL, BYO_OPENING_FROM_CAMPAIGN, BYO_SAVE_SCOREBOARD_URL } from '../constants';
const initialState = {
    isModalOpen: false,
    isOpeningFromCampaign: false,
    scoreboardUrl: ''
};
//eslint-disable-next-line complexity
const appReducer = (state = initialState, action = { type: '', payload: '' }) => {
    if (!action) {
        return state;
    }
    if (action.type === BYO_OPEN_MODAL) {
        return Object.assign(Object.assign({}, state), { isModalOpen: true });
    }
    if (action.type === BYO_CLOSE_MODAL) {
        return Object.assign(Object.assign({}, state), { isModalOpen: false });
    }
    if (action.type === BYO_OPENING_FROM_CAMPAIGN) {
        return Object.assign(Object.assign({}, state), { isOpeningFromCampaign: action.payload });
    }
    if (action.type === BYO_SAVE_SCOREBOARD_URL) {
        return Object.assign(Object.assign({}, state), { scoreboardUrl: action.payload.url });
    }
    return state;
};
export default appReducer;
